import { MDXEditorMethods, MDXEditorProps } from '@mdxeditor/editor'
import '@mdxeditor/editor/style.css'
import { RefAttributes, useEffect, useRef, useState } from 'react'

const PopUpNotificationMdxEditorWrapper = (
    props: MDXEditorProps & RefAttributes<MDXEditorMethods>,
) => {
    const ref = useRef<MDXEditorMethods>(null)
    const [mdxEditorModule, setMdxEditorModule] = useState<
        typeof import('@mdxeditor/editor') | null
    >(null)

    useEffect(() => {
        import('@mdxeditor/editor').then((module) => {
            setMdxEditorModule(module)
        })
    }, [])

    if (!mdxEditorModule) {
        return null
    }

    const {
        BoldItalicUnderlineToggles,
        CreateLink,
        linkDialogPlugin,
        linkPlugin,
        listsPlugin,
        ListsToggle,
        toolbarPlugin,
        MDXEditor,
    } = mdxEditorModule

    return (
        <MDXEditor
            {...props}
            contentEditableClassName={'prose px-6 py-4'}
            ref={ref}
            plugins={[
                linkDialogPlugin(),
                linkPlugin(),
                listsPlugin(),
                toolbarPlugin({
                    toolbarContents: () => (
                        <>
                            {' '}
                            <BoldItalicUnderlineToggles />
                            <CreateLink />
                            <ListsToggle options={['bullet', 'number']} />
                        </>
                    ),
                }),
            ]}
        />
    )
}

export default PopUpNotificationMdxEditorWrapper
